var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    fill: "none",
    stroke: "currentColor",
    className: "books_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.5h6M7.5 15.5h6M1.5 3.5h6v18h-6zM7.5 3.5h6v18h-6zM16.128 15.646l5.855-1.315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.499 3.937l5.854-1.314 3.942 17.563-5.854 1.314z",
    strokeWidth: 0.99998
  }))));
}

export default SvgBooks;